import { GateListModalForm } from "./GateListModalForm";

const GateListModalFormWrapper = ({
  listing,
  selectedListingId,
  gateLists,
  getGateLists,
  setOpenGateListModal,
  setOpenTimelineModal,
  openGateAddModal,
  setOpenGateAddModal
}) => {
    return (
      <GateListModalForm
      listing={listing}
      selectedListingId={selectedListingId}
      gateLists={gateLists}
      getGateLists={getGateLists}
      setOpenGateListModal={setOpenGateListModal}
      setOpenTimelineModal={setOpenTimelineModal}
      openGateAddModal={openGateAddModal}
      setOpenGateAddModal={setOpenGateAddModal}
      />
    );
  }

export { GateListModalFormWrapper };
